import React from 'react';
import { connect } from 'react-redux';
import { addError } from '@ers/root/toasts/toasts.actions';
import { Typo } from '@ers/ui';
import { Primary } from '@ers/ui/Buttons';

const { SentryLogger: Logger } = require('@ers/errors/');

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, errorInfo) {
        const { dispatch } = this.props;
        dispatch(addError(`Coś poszło nie tak. Odśwież stronę.`));
        Logger.error(error);
    }

    static getDerivedStateFromError(error) {
        // Zaktualizuj stan, aby następny render pokazał zastępcze UI.
        return { hasError: true };
    }

    render() {
        const { hasError } = this.state;
        const { children } = this.props;
        if (hasError) {
            return null;
        }

        return children;
    }
}

export class MainErrorBoundary extends ErrorBoundary {
        handleClick = () => {
            window.location.reload();
        }

        render() {
            const { hasError } = this.state;
            const { children } = this.props;
            if (hasError) {
                return (
                    <>
                        <Typo.Subheader>Coś poszło nie tak...</Typo.Subheader>
                        <Primary onClick={this.handleClick}>
                            Radzimy odświeżyć stronę
                        </Primary>
                    </>
                );
            }

            return children;
        }
}
export default connect()(ErrorBoundary);